import ListBox from "@ingka/list-box";
import "@ingka/list-box/dist/style.css";
import "@ingka/svg-icon/dist/style.css";
import { ReactNode } from "react";

interface ListBoxProps {
  children: ReactNode | ReactNode[];
  className?: string;
  multiple?: boolean;
  open: boolean;
  position?: "left" | "right";
  value?: string[];
  popupMode?: boolean;
}

export const FixaListBox = (props: ListBoxProps) => {
  return <ListBox {...props} />;
};
